import React, {ReactElement, useState, useEffect} from 'react';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
  Typography,
  DialogTitle,
  // Checkbox,
  MenuItem,
  Divider,
  Select,
  ListItemText,
  FormControl,
  Link,
  FormHelperText
} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import {useForm, Controller} from 'react-hook-form';
import StyledOutlinedInput from '@components/system/FormInput/StyledOutlinedInput';
import {Trans, useTranslation} from 'react-i18next';
import {useSnackbar} from 'notistack';
import {
  createPatientCopay,
  getGuarantorPatientsAndDueAmount,
  patientMiscChargeTypes
} from '@shared/services/PatientsServices';
import CardPayDialog from '@components/system/CardPayDialog/CardPayDialog';
import {
  _guarantorPayAmount,
  _guarantorPayCashAmount,
  _updatePaymentType,
  _saveAdhocPaymentsData,
  _saveClinicDetails
} from '@shared/store/actions/PaymentActions';
import {connect, useDispatch, useSelector} from 'react-redux';
import CurrencyFormatter, {
  getFormattedValue
} from '@components/system/CurrencyFormatter/CurrencyFormatter';
import {getChargeTypeLabel, PaymentTypes} from '@shared/constants/Mapping';
import CustomSelectField from '../ClinicGroups/AddUser/CustomSelectField';
import {FilterClinicStyles} from '../Invoices/DueInvoices/DueInvoices';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import NumberFormat from 'react-number-format';
import CustomInputField from '@components/system/FormInput/StyledOutlinedInput';
import HelperUtils from '@shared/utils/HelperUtils';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import {APP, BORDER_PRIMARY_COLOR} from 'src/style/variable';
import './AdhocPaymentDashboard.scss';
import CopayAlertDialog from './CopayAlert';
import {getAllClinics} from '@shared/services/ClinicServices';
import CustomDropDown from '@components/system/CustomDropDown/CustomDropDown';
import {_setClinics} from '@shared/store/actions/ClinicActions';
import {getGuarantorBalancesFromMultipleLocations} from '@shared/services/DueInvoiceServices';
import Loader from '@components/framework/loader/Loader';
import {CommunicationService} from 'src/service/CommunicationService';

// styling for component
const confirmDialogStyle = makeStyles(() =>
  createStyles({
    title: {
      fontSize: '1.5rem',
      padding: '12px 0'
    },
    actionWrapper: {
      display: 'flex !important',
      padding: '16px 24px 20px 24px'
    },
    description: {
      fontSize: '1rem',
      marginTop: '32px'
    },
    includeDueAmount: {
      backgroundColor: APP.COLOR.BACKGROUND.WARNING,
      justifyContent: 'space-between',
      alignItems: 'center',
      display: 'flex',
      marginTop: '1rem',
      padding: '1rem'
    },
    dividerView: {
      borderTop: '1px outset',
      marginTop: '1rem',
      marginBottom: '1rem'
    },
    label: {
      marginTop: '0.5rem',
      marginBottom: '0.5rem'
    },
    insuranceNameLabel: {
      marginTop: '0.5rem'
    },
    amount: {
      width: '100%'
    },
    flex: {
      display: 'flex'
    },
    chareTypeDropDownView: {
      flex: 1,
      marginRight: '0.5rem'
    },
    amountSectionView: {
      flex: 1
      // marginLeft: '0.5rem'
    },
    dueInformation: {
      fontSize: '1.3rem'
    },
    direction: {
      flexDirection: 'row'
    },
    dialogSubContentPadding: {
      paddingTop: '1rem'
    },
    loaderWrapper: {
      display: 'flex',
      justifyContent: 'center',
      padding: '1rem'
    },
    errorheight: {
      height: '1rem'
    }
  })
);

const textArea = {
  width: '100%',
  borderColor: BORDER_PRIMARY_COLOR,
  borderRadius: '3pt',
  paddingTop: '1rem',
  paddingLeft: '0.8rem',
  fontFamily: APP.FONT_FAMILY.REGULAR,
  fontSize: '1rem',
  paddingBottom: '1rem',
  minHeight: '100px'
};

// interface for Confirmation Dialog props
interface ConfirmationDialogProps {
  open: boolean;
  title: any;
  subtitle: string;
  body?: any;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onClose(response: 'confirm' | 'cancel'): void;
  paymentMethod: string;
  guarantor?: any;
  clinics?: any;
  _guarantorPayAmount?: any;
  _guarantorPayCashAmount?: any;
  _updatePaymentType?: any;
  _saveAdhocPaymentsData?: any;
  _saveClinicDetails?: any;
  patientShared?: boolean;
}

// FIXME: The props are not configured properly
// FIXME: Component should be scalable with minimum props
const AdhocPaymentDashboard = (
  props: ConfirmationDialogProps
): ReactElement => {
  const {t} = useTranslation();
  const styleClasses = confirmDialogStyle();
  const ClinicClasses = FilterClinicStyles();
  const {enqueueSnackbar} = useSnackbar();
  // props de-structure
  const {
    open,
    onClose,
    title,
    subtitle,
    guarantor,
    paymentMethod,
    // clinics,
    patientShared = false
  } = props;
  const [guarantorPatients, setGuarantorPatients] = useState<any[]>([]);
  const [guarantorDueAmount, setGuarantorDueAmount] = useState<number>(0);
  const [totalAmount, updateTotalAmount] = useState<number>(0);
  const [guarantorDueIncluded] = useState<boolean>(false);
  const [cardPopUpOpen, setCardPopUpOpen] = useState<boolean>(false);
  // const [cardPatientDetails, setCardPatientDetails] = useState<any>({});
  const [clinic, setClinic] = useState<any>(undefined);
  const [clinicPaymentNote, setClinicPaymentNote] = useState<string>('');
  const [clinicInsuranceName, setClinicInsuranceName] = useState<string>('');
  const [, setShowClinicDropdown] = useState<boolean>(patientShared);
  const [loader, setLoader] = useState<boolean>(false);
  const { control, errors, watch }: any = useForm({
    mode: 'all',
    resolver: async (values: any) => {
      const error: any = {};
      const { notes: _notes } = values;
      if (_notes?.length > 100) {
        error.notes = 'PAYMENTS_LOGIN.CARD.PAY_NOTE_ERROR_MESSAGE';
      }
      return {
        values, errors: error
      }
    }
  });
  const watchNotes = watch('notes');
  const [copaySuccessAlert, setCopaySuccessAlert] = useState<boolean>(false);
  const [clinics, setClinicList] = useState<any[]>([]);
  const [chargeType, setChargeTypes] = useState([]);
  const [selectedCharge, setSelectedCharge] = useState<string>('');
  const [selectedChargeLabel, setSelectedChargeLabel] = useState<string>('');
  const [forceUpate, setForceUpdate] = useState<number>(0);
  const [chargeDescription, setChargeDescription] = useState('');
  const groupId: any = useSelector((state: any) => state.auth.groupId || null);
  // BY DEFAULT IS_ADHOC IS TRUE
  const [isAdhoc, setIsAdhoc] = useState(true);

  const selectedClinicId: any = useSelector(
    (state: any) => state.clinics.selectedClinicId || null
  );
  const [collectCopay, setCollectCopay] = useState(false);

  const [copayAlert, updateCopayAlert] = useState<boolean>(false);
  const [dueBalance, updateDueBalance] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  const dispatch = useDispatch();

  // API CALLS
  const getGroupClinics = () => {
    getAllClinics(groupId)
      .then((res: any) => {
        if (res && res?.data && res?.data?.rows) {
          setClinicList(res.data.rows);
          dispatch(_setClinics(res.data.rows));
        } else {
          setClinicList([]);
        }
      })
      .catch((error: any) => {
        enqueueSnackbar(
          t('CLINICS.CLINIC_GROUP_CLINICS_ERROR'),
          SnackBarConfig('e')
        );
        throw error;
      });
  };

  const getGuarantorDueBalances = async (): Promise<void> => {
    let clinicIdParam = selectedClinicId && selectedClinicId[0];
    if (!clinicIdParam) {
      clinicIdParam = guarantor && guarantor?.clinic_id;
    }
    try {
      if (clinicIdParam && guarantor && guarantor?.id) {
        const guarantorDues = await getGuarantorBalancesFromMultipleLocations(
          groupId,
          guarantor?.id,
          clinicIdParam,
          false
        );
        if (
          guarantorDues &&
          guarantorDues?.data &&
          guarantorDues?.data?.summary?.statement_current_due_amount
        ) {
          updateDueBalance(
            guarantorDues?.data?.summary?.statement_current_due_amount
          );
          updateCopayAlert(true);
        }
      }
    } catch (error: any) {
      enqueueSnackbar(error && error?.message, SnackBarConfig('e'));
      throw error;
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getGroupClinics();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getGuarantorDueBalances();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = React.useCallback(
    (response: 'confirm' | 'cancel') => {
      setClinicPaymentNote('');
      setClinicInsuranceName('');
      setClinic(undefined);
      if (typeof onClose === 'function') {
        onClose(response);
      }
    },
    [onClose]
  );

  const fetchPatientMiscChargeTypes = async (patients: any) => {
    patientMiscChargeTypes(guarantor.clinic_group_id, guarantor?.clinic_id)
      .then((res: any) => {
        if (res?.data?.length) {
          setChargeTypes(res?.data);
          if (
            res.data.length === 1 &&
            res.data[0]?.label &&
            res.data[0]?.value
          ) {
            setSelectedCharge(res.data[0].value);
            setSelectedChargeLabel(res.data[0].label);
            setForceUpdate(forceUpate + 1);
            if (
              patients !== null &&
              patients !== undefined &&
              Array.isArray(patients) &&
              patients.length > 0
            ) {
              // Add default charge type to all patient objects
              patients.forEach(patient => {
                patient.charge_type = res.data[0].value;
              });
              setGuarantorPatients(patients);
            }
          }
        }
      })
      .catch(error => {
        enqueueSnackbar(error.message, SnackBarConfig('e'));
      });
  };

  const fetchGuarantorInvoicesAndDueAmount = () => {
    getGuarantorPatientsAndDueAmount(guarantor.clinic_group_id, guarantor.id)
      .then((res: any) => {
        if (res?.data?.due_amount) {
          setGuarantorDueAmount(res?.data.due_amount);
        }
        if (res.data?.patients) {
          let totalPatientAmount = 0;
          res.data.patients.forEach((p: any) => {
            totalPatientAmount += p.amount;
          });
          updateTotalAmount(totalPatientAmount);
          setGuarantorPatients(res.data?.patients);
          let total = 0;
          res.data?.patients.map((item: any) => {
            if (item.amount) {
              total += Number(item.amount);
            }
          });
          updateTotalAmount(total);
        }
        fetchPatientMiscChargeTypes(res.data?.patients);
      })
      .catch(error => {
        enqueueSnackbar(error.message, SnackBarConfig('e'));
      });
  };

  useEffect(() => {
    if (
      [
        PaymentTypes.AD_HOC_PATIENT_PAYMENT,
        PaymentTypes.PATIENT_COPAY_PAYMENT
      ].includes(paymentMethod)
    ) {
      fetchGuarantorInvoicesAndDueAmount();
    } else if (paymentMethod === PaymentTypes.AD_HOC_CLINIC_PAYMENT) {
      setShowClinicDropdown(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMethod]);

  useEffect(() => {
    if (clinics?.length == 1) {
      setClinic(clinics[0]);
    }
    if (Array.isArray(clinics)) {
      const filteredClinics = clinics.filter(
        // guarantor can be undefined some time, in that case take selectedClinicId[0]
        (c: any) =>
          guarantor?.clinic_id
            ? c?.id === guarantor?.clinic_id
            : c?.id === selectedClinicId?.[0]
      );
      if (filteredClinics.length === 1) {
        setClinic(filteredClinics[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinics, guarantor?.clinic_id]);

  // const handleOnCheckIncludeGuarantorDue = () => {
  //   if (guarantorDueIncluded) {
  //     updatedGuarantorDueIncluded(false);
  //     updateTotalAmount(
  //       parseFloat((totalAmount - Number(guarantorDueAmount)).toFixed(2))
  //     );
  //   } else {
  //     updatedGuarantorDueIncluded(true);
  //     updateTotalAmount(
  //       parseFloat((totalAmount + Number(guarantorDueAmount)).toFixed(2))
  //     );
  //   }
  // };

  const validatePatientChargeTypes = (): any => {
    const errorObject = {
      flag: false,
      message: ''
    };
    const filterGuarantorPatients = guarantorPatients.filter(
      (patient: any) => patient.charge_type && patient.amount
    );
    const isAllChargesTypeExist: any = filterGuarantorPatients.filter(
      (patient: any) => !patient.charge_type && patient.amount > 0
    );

    if (isAllChargesTypeExist.length > 0) {
      return {
        flag: true,
        message: t('AD_HOC.ADD_CHARGE_TYPE')
      };
    }

    const isAllChargesTypesAmount: any = filterGuarantorPatients.filter(
      (patient: any) => patient.charge_type && patient.amount <= 0
    );

    if (isAllChargesTypesAmount.length > 0) {
      return {
        flag: true,
        message: t('AD_HOC.VALID_AMOUNT')
      };
    }

    const isAllChargesDescriptionExist: any = filterGuarantorPatients.filter(
      (patient: any) => !patient.payment_note && patient.amount > 0
    );

    if (isAllChargesDescriptionExist.length > 0) {
      return {
        flag: true,
        message: t('AD_HOC.ENTER_DESCRIPTION')
      };
    }

    return errorObject;
  };

  const openCardPayPopover = () => {
    if (!clinic) {
      enqueueSnackbar(t('AD_HOC.SELECT_CLINIC'), SnackBarConfig('e'));
      return;
    }
    if (totalAmount <= 0) {
      return;
    }
    if (!chargeDescription) {
      enqueueSnackbar(t('AD_HOC.ENTER_DESCRIPTION'), SnackBarConfig('e'));
      return;
    }

    const errorObject = validatePatientChargeTypes();

    if (errorObject.flag) {
      enqueueSnackbar(errorObject.message, SnackBarConfig('e'));
      return;
    }

    if (paymentMethod === PaymentTypes.AD_HOC_CLINIC_PAYMENT && !clinic) {
      enqueueSnackbar(t('AD_HOC.SELECT_CLINIC'), SnackBarConfig('e'));
      return;
    }
    if (
      [
        PaymentTypes.AD_HOC_PATIENT_PAYMENT,
        PaymentTypes.PATIENT_COPAY_PAYMENT
      ].includes(paymentMethod) &&
      patientShared &&
      !clinic
    ) {
      enqueueSnackbar(t('AD_HOC.SELECT_CLINIC'), SnackBarConfig('e'));
      return;
    }
    props._guarantorPayAmount(getFormattedValue(totalAmount, true));
    props._guarantorPayCashAmount(getFormattedValue(totalAmount, true))
    props._updatePaymentType(paymentMethod);
    if (
      [
        PaymentTypes.AD_HOC_PATIENT_PAYMENT,
        PaymentTypes.PATIENT_COPAY_PAYMENT
      ].includes(paymentMethod)
    ) {
      const patients: any = guarantorPatients
        .filter((patient: any) => patient.amount > 0)
        .map((patient: any) => {
          return {
            charge_type: patient.charge_type ?? '',
            patient_id: patient.id,
            amount: patient.amount,
            description: patient.payment_note ?? ''
          };
        });

      props._saveAdhocPaymentsData({
        patients: patients,
        guarantorDueIncluded,
        guarantor: guarantor
      });
      setCollectCopay(true);
    } else {
      props._saveAdhocPaymentsData({
        payment_note: clinicPaymentNote,
        insurance_name: clinicInsuranceName
      });
    }
    setCardPopUpOpen(true);
  };

  const handleAddCopay = () => {
    if (!clinic) {
      if (!patientShared) {
        enqueueSnackbar(t('AD_HOC.SELECT_CLINIC'), SnackBarConfig('e'));
        return;
      }
    }
    if (totalAmount <= 0) {
      return;
    }
    if (!chargeDescription) {
      enqueueSnackbar(t('AD_HOC.ENTER_DESCRIPTION'), SnackBarConfig('e'));
      return;
    }
    if (
      paymentMethod === PaymentTypes.AD_HOC_PATIENT_PAYMENT &&
      patientShared &&
      !clinic
    ) {
      enqueueSnackbar(t('AD_HOC.SELECT_CLINIC'), SnackBarConfig('e'));
      return;
    }

    const errorObject = validatePatientChargeTypes();

    if (errorObject.flag) {
      enqueueSnackbar(errorObject.message, SnackBarConfig('e'));
      return;
    }
    const patients: any = guarantorPatients
      .filter((patient: any) => patient.amount > 0)
      .map((patient: any) => {
        return {
          patient_id: patient.id,
          amount: patient.amount,
          description: patient.payment_note ?? '',
          charge_type: patient.charge_type ?? ''
        };
      });
    setLoader(true);
    createPatientCopay(guarantor.clinic_group_id, {
      patients,
      clinic_id: clinic ? clinic.id : guarantor.clinic_id,
      guarantor_id: guarantor.id
    })
      .then(res => {
        enqueueSnackbar(res.message, SnackBarConfig('s'));
        // handleClose('confirm');
        setCopaySuccessAlert(true);

        // Trigger an event when patient copay is added
        CommunicationService.sendEvent({
          action: 'PATIENT_COPAY_ADDED',
          data: null
        });
      })
      .catch(err => {
        enqueueSnackbar(err.message, SnackBarConfig('e'));
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const closeCardPayPopOver = () => {
    setCardPopUpOpen(false);
    setIsAdhoc(true);
    props._guarantorPayAmount(0);
    props._guarantorPayCashAmount(0)
    props._updatePaymentType('');
    props._saveAdhocPaymentsData({});
    props._saveClinicDetails({});
  };

  const renderCardPopUp = (): React.ReactElement => {
    return (
      <CardPayDialog
        isAdhoc={isAdhoc}
        guarantorId={guarantor ? guarantor.id : null}
        clinicId={clinic.id}
        clinicGroupId={groupId}
        guarantorName={
          guarantor
            ? HelperUtils.commaSeparatedFullName(
              guarantor.first_name,
              guarantor.last_name,
              guarantor.middle_name
            )
            : clinic.name
        }
        open={cardPopUpOpen}
        handleClose={reason => {
          if (reason === 'success') {
            handleClose('confirm');
          }
          closeCardPayPopOver();
          handleClose('cancel');
        }}
        collectCopay={collectCopay}
      // disableBackdropClick={true}
      />
    );
  };

  // IN CASE OF COPAY PAYMENT SHOW ALL THE CLINICS, IF PATIENT SHARED IS ON
  let filteredClinics = clinics;
  if (paymentMethod === PaymentTypes.PATIENT_COPAY_PAYMENT && !patientShared) {
    filteredClinics = clinics.filter(clinicItem =>
      guarantor?.clinic_id
        ? clinicItem?.id === guarantor?.clinic_id
        : clinicItem?.id === selectedClinicId?.[0]
    );
  }

  const renderClinicSelect = (): ReactElement => {
    return (
      <div
        className="filters-view"
      //  hidden={showClinicDropdown}
      >
        <div className={styleClasses.label}>{t('AD_HOC.SELECT_CLINIC')}</div>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          data-test-id="pcl-payments-selectPracticeInVirtualPay"
          value={
            clinic ? [clinic.name] : [t('AD_HOC.SELECT_CLINIC_PLACEHOLDER')]
          }
          variant="outlined"
          disabled={filteredClinics.length === 1}
          fullWidth={true}
          style={filteredClinics.length === 1 ? {opacity: 0.5} : {}}
          input={<CustomSelectField />}
          IconComponent={KeyboardArrowDownIcon}>
          <div>
            <Divider />
            <div className={ClinicClasses.ClinicMenu}>
              {filteredClinics.map((clinic_: any) => (
                <MenuItem
                  key={clinic_.id}
                  value={clinic_.name}
                  onClick={(): void => {
                    setClinic(clinic_);
                  }}>
                  <ListItemText
                    className={[
                      ClinicClasses.secondary,
                      ClinicClasses.primary
                    ].join(' ')}
                    primary={clinic_.name}
                    secondary={
                      <>
                        <span
                          className={ClinicClasses.clinicMenuEmrProviderText}>
                          {clinic_.emr_provider_detail?.name}
                        </span>
                        &nbsp;/&nbsp;
                        <span>
                          {clinic_.city}, {clinic_.country}
                        </span>
                      </>
                    }
                  />
                  <Radio checked={clinic?.id === clinic_.id} />
                </MenuItem>
              ))}
            </div>
          </div>
        </Select>
      </div>
    );
  };

  const openPayPopOver = () => {
    setCardPopUpOpen(true);
    // SETTING IS ADHOC TO FALSE WHEN CLICKING ON THE CLICK HERE TEXT IN COPAY ALERT
    setIsAdhoc(false);
    // UPDATING STATEMENT BALANCE AND PAYMENT TYPE TO REDUX,
    props._updatePaymentType(PaymentTypes.STATEMENT_PAYMENT);
    props._guarantorPayAmount(dueBalance);
    props._guarantorPayCashAmount(dueBalance);
  };

  const renderBody = () => {
    return (
      <div>
        {renderClinicSelect()}
        {[
          PaymentTypes.AD_HOC_PATIENT_PAYMENT,
          PaymentTypes.PATIENT_COPAY_PAYMENT
        ].includes(paymentMethod) ? (
          guarantorPatients.map((patient: any, idx: number) => {
            return (
              <div key={patient.id}>
                {idx !== 0 && <div className={styleClasses.dividerView} />}
                <Typography className={styleClasses.label}>
                  {
                    <Trans
                      i18nKey={'AD_HOC.PATIENT_LABEL'}
                      values={{
                        patientName: HelperUtils.commaSeparatedFullName(
                          patient.first_name,
                          patient.last_name,
                          patient.middle_name
                        )
                      }}
                      components={[<strong key={'X'} />]}
                    />
                  }
                </Typography>

                <div
                //  className={styleClasses.flex}
                >
                  {/* CHARGE TYPES SECTION */}
                  <div className={styleClasses.chareTypeDropDownView}>
                    <div className={styleClasses.label}>
                      {t('AD_HOC.SELECT_CHARGE_TYPE')}
                    </div>

                    <CustomDropDown
                      dropDownList={chargeType}
                      placeHolderText={t('AD_HOC.SELECT_CHARGE_TYPE')}
                      dropDownHeaderText={t('AD_HOC.SELECT_CHARGE_TYPE')}
                      handleAction={(item: any) => {
                        patient.charge_type = item?.value;
                        setSelectedCharge(item?.value);
                      }}
                      defaultValue={selectedChargeLabel}
                      forceUpate={forceUpate}
                    />
                  </div>

                  {/* AMOUNT CHARE SECTION */}
                  <div className={styleClasses.amountSectionView}>
                    <div className={styleClasses.label}>
                      {t('AD_HOC.COPAY_OR_OTHER_CHARGE_AMOUNT')}
                    </div>
                    <NumberFormat
                      value={patient.amount || ''}
                      onChange={(e: any) => {
                        const amount = Number(
                          e.target.value
                            ?.toString()
                            .replace(/\$/g, '')
                            .replace(/,/g, '') ?? '0'
                        );
                        const updatedTotalAmount =
                          totalAmount - (patient?.amount ?? 0) + amount;
                        if (
                          guarantorDueIncluded &&
                          updatedTotalAmount < guarantorDueAmount
                        ) {
                          updateTotalAmount(guarantorDueAmount);
                        } else {
                          updateTotalAmount(updatedTotalAmount);
                        }
                        patient.amount = amount;
                      }}
                      customInput={CustomInputField}
                      thousandSeparator={true}
                      prefix={'$'}
                      placeholder={HelperUtils.formatCurrencyAmount(0, true)}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      disabled={false}
                      className={styleClasses.amount}
                    />
                  </div>

                  <div className={styleClasses.label}>
                    {t('AD_HOC.PAY_NOTE_OF_PATIENT', {
                      name: HelperUtils.fullName(
                        patient.first_name,
                        patient.last_name
                      )
                    })}
                  </div>
                  <TextareaAutosize
                    rowsMax={10}
                    aria-label="maximum height"
                    placeholder={t('PAYMENTS_LOGIN.CARD.PAY_NOTE')}
                    style={{...textArea}}
                    onChange={(event: any) => {
                      setChargeDescription(event.target.value ?? '');
                      patient.payment_note = event.target.value ?? '';
                    }}
                  />
                  {/* <div className={styleClasses.label}>
                    {t('AD_HOC.COPAY_OR_OTHER_CHARGE_AMOUNT')}
                  </div>
                  <NumberFormat
                    value={patient.amount || ''}
                    onChange={(e: any) => {
                      const amount = Number(
                        e.target.value
                          ?.toString()
                          .replace(/\$/g, '')
                          .replace(/,/g, '') ?? '0'
                      );
                      const updatedTotalAmount =
                        totalAmount - (patient?.amount ?? 0) + amount;
                      if (
                        guarantorDueIncluded &&
                        updatedTotalAmount < guarantorDueAmount
                      ) {
                        updateTotalAmount(guarantorDueAmount);
                      } else {
                        updateTotalAmount(updatedTotalAmount);
                      }
                      patient.amount = amount;
                    }}
                    customInput={CustomInputField}
                    thousandSeparator={true}
                    prefix={'$'}
                    placeholder={HelperUtils.formatCurrencyAmount(0, true)}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    disabled={false}
                    className={styleClasses.amount}
                  /> */}
                  {/* <div className={styleClasses.label}>
                    {t('AD_HOC.PAY_NOTE_OF_PATIENT', {
                      name: HelperUtils.fullName(
                        patient.first_name,
                        patient.last_name
                      )
                    })}
                  </div> */}
                </div>
              </div>
            );
          })
        ) : (
          <div>
            <div className={styleClasses.label}>
              {t('AD_HOC.PAY_AMOUNT_FOR_CLINIC')}
            </div>
            <NumberFormat
              value={totalAmount ? totalAmount : ''}
              onChange={(e: any) => {
                const amount = Number(
                  e.target.value
                    ?.toString()
                    .replace(/\$/g, '')
                    .replace(/,/g, '') ?? '0'
                );
                // If amount is more than zero, charge button is enabled,
                // else charge button is disabled and display $0.00 amount (isNaN() is used to handel '-').
                if (!isNaN(amount) && amount > 0) updateTotalAmount(amount);
                else {
                  updateTotalAmount(0);
                }
              }}
              customInput={CustomInputField}
              thousandSeparator={true}
              prefix={'$'}
              placeholder={HelperUtils.formatCurrencyAmount(0, true)}
              decimalScale={2}
              fixedDecimalScale={true}
              disabled={false}
              className={styleClasses.amount}
            />
            <div className={styleClasses.insuranceNameLabel}>
              {t('AD_HOC.INSURANCE_NAME')}
            </div>
            <FormControl
              fullWidth={true}
              variant="outlined"
              style={{paddingBottom: '0'}}
              onChange={(event: any) => {
                setClinicInsuranceName(event.target.value ?? '');
              }}>
              <Controller
                id={'insurance_name'}
                as={StyledOutlinedInput}
                margin={'dense'}
                control={control}
                name={'insurance_name'}
                type={'text'}
                value={clinicInsuranceName}
                autoComplete="on"
                placeholder={t('AD_HOC.INSURANCE_NAME_PLACEHOLDER')}
                defaultValue={''}
              />
            </FormControl>
            <div className={styleClasses.insuranceNameLabel}>
              {t('AD_HOC.PATIENT_PAY_NOTE')}
            </div>
            {/* <TextareaAutosize
              rowsMax={10}
              aria-label="maximum height"
              placeholder={t('PAYMENTS_LOGIN.CARD.PAY_NOTE')}
              style={{...textArea}}
              onChange={(event: any) => {
                setChargeDescription(event.target.value ?? '');
                setClinicPaymentNote(event.target.value ?? '');
              }}
              value={clinicPaymentNote}
            /> */}
            <FormControl
              error={!!errors.notes}
              fullWidth={true}
              variant="outlined"
              style={{ paddingBottom: '0' }}
              onChange={(event: any) => {
                setChargeDescription(event.target.value ?? '');
                setClinicPaymentNote(event.target.value ?? '');
              }}>
              <Controller
                id={'notes'}
                as={StyledOutlinedInput}
                margin={'dense'}
                control={control}
                name={'notes'}
                type={'text'}
                value={clinicPaymentNote}
                autoComplete="on"
                placeholder={t('PAYMENTS_LOGIN.CARD.PAY_NOTE')}
                defaultValue={''}
                error={!!errors.notes}
              />
              <div className={styleClasses.errorheight}>
                {errors.notes && (
                  <FormHelperText>{t(errors.notes)}</FormHelperText>
                )}
              </div>
            </FormControl>
          </div>
        )}
        {/* {guarantorDueAmount > 0 ? (
          <div className={styleClasses.includeDueAmount}>
            <div>
              {
                <Trans
                  i18nKey={'AD_HOC.INCLUDE_GUARANTOR_DUE_AMOUNT'}
                  values={{
                    amount: `$${getFormattedValue(guarantorDueAmount, true)}`,
                    name: guarantor.name
                  }}
                  components={[<strong key={'X'} />]}
                />
              }
            </div>
            <Checkbox
              size={'medium'}
              className={'adhoc-payment-dashboard-checkbox'}
              onChange={handleOnCheckIncludeGuarantorDue}
              checked={guarantorDueIncluded}
              inputProps={{'aria-label': 'controlled'}}
            />
          </div>
        ) : (
          ''
        )} */}
      </div>
    );
  };

  const renderCopayAlertContent = (): ReactElement => {
    return (
      <>
        <DialogTitle
          disableTypography
          data-test-id="pcl-copayComponent-confirmAlert">
          {t('ADD_COPAY_ALERT.TITLE')}
        </DialogTitle>
        <DialogContent dividers>
          <div className={styleClasses.direction}>
            <div
              className={[
                styleClasses.dueInformation,
                'highlight-information-text'
              ].join(' ')}>
              <Trans
                i18nKey={'ADD_COPAY_ALERT.SUB_TITLE'}
                values={{
                  statement_balance: `$${dueBalance}`
                }}
                components={[
                  <strong key={'X'} />,
                  <Link
                    key={'Y'}
                    onClick={() => {
                      openPayPopOver();
                    }}
                  />
                ]}
              />
            </div>
            <div className={styleClasses.dialogSubContentPadding}>
              {t('ADD_COPAY_ALERT.BODY')}
            </div>
          </div>
        </DialogContent>
        <DialogActions style={{ display: 'flex' }}>
          <Button
            onClick={() => {
              updateCopayAlert(false);
              handleClose('cancel');
            }}
            disabled={loader}>
            {t('DUE_INVOICES.NOTIFICATION_DIALOG.BUTTON_CANCEL')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              updateCopayAlert(false);
            }}>
            {t('ADD_COPAY_ALERT.ADD_COLLECT_COPAY')}
          </Button>
        </DialogActions>
      </>
    );
  };

  const renderAddCopayContent = (): ReactElement => {
    return (
      <>
        <DialogTitle disableTypography>{title}</DialogTitle>
        <DialogContent dividers>
          <div className="sub-title">{subtitle}</div>
          <div>{renderBody()}</div>
        </DialogContent>
        <DialogActions style={{display: 'flex'}}>
          <Button
            onClick={() => {
              updateCopayAlert(false);
              handleClose('cancel');
            }}
            disabled={loader}>
            {t('DUE_INVOICES.NOTIFICATION_DIALOG.BUTTON_CANCEL')}
          </Button>

          <Button
            variant="contained"
            color="primary"
            data-test-id="pcl-payments-chargeAmountButton"
            onClick={() => {
              openCardPayPopover();
            }}
            disabled={loader || totalAmount <= 0 || watchNotes?.length > 100}>
            {paymentMethod === PaymentTypes.AD_HOC_CLINIC_PAYMENT
              ? t('AD_HOC.CHARGE')
              : t('AD_HOC.PAY')}
            &nbsp;
            <CurrencyFormatter
              value={totalAmount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              ignoreRound={true}
              useSign={true}
            />
          </Button>
          {[
            PaymentTypes.AD_HOC_PATIENT_PAYMENT,
            PaymentTypes.PATIENT_COPAY_PAYMENT
          ].includes(paymentMethod) && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  handleAddCopay();
                }}
                disabled={
                  loader || totalAmount <= 0 || selectedCharge?.length == 0
                }>
                {t('COPAY.ADD_CHARGE')}
              </Button>
            )}
        </DialogActions>
      </>
    );
  };

  // NEED TO SHOW COPAY DIALOG WHEN PAYMENT METHOD IS NOT AD HOC CLINIC PAYMENT
  const shouldShowCopay = paymentMethod !== PaymentTypes.AD_HOC_CLINIC_PAYMENT;
  return (
    <div>
      <Dialog
        maxWidth={'sm'}
        fullWidth={true}
        open={open}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        onClose={handleClose}
        aria-labelledby="confirm-dialog"
        aria-describedby="confirm-dialog">
        {loading ? (
          <div className={styleClasses.loaderWrapper}>
            <Loader />
          </div>
        ) : shouldShowCopay && copayAlert ? (
          renderCopayAlertContent()
        ) : (
          renderAddCopayContent()
        )}
      </Dialog>
      {cardPopUpOpen && renderCardPopUp()}
      {copaySuccessAlert && (
        <CopayAlertDialog
          open={copaySuccessAlert}
          title={
            ((
              <Trans
                i18nKey={'COPAY.ALERT.TITLE'}
                values={{
                  guarantorName: HelperUtils.commaSeparatedFullName(
                    guarantor.first_name,
                    guarantor.last_name,
                    guarantor.middle_name
                  ),
                  chargeType: t(getChargeTypeLabel(selectedCharge))
                }}
                components={[<strong key={'X'} />]}
              />
            ) as unknown) as string
          }
          description={t('COPAY.ALERT.SUB_TITLE')}
          onClose={() => {
            handleClose('confirm');
            setCopaySuccessAlert(false);
          }}
          closeButton={t('COPAY.ALERT.CLOSE')}
        />
      )}
    </div>
  );
};

export default connect(
  () => {
    return {};
  },
  {
    _guarantorPayAmount,
    _guarantorPayCashAmount,
    _updatePaymentType,
    _saveAdhocPaymentsData,
    _saveClinicDetails
  }
)(AdhocPaymentDashboard);
